import script from "./authentication.vue?vue&type=script&setup=true&lang=js"
export * from "./authentication.vue?vue&type=script&setup=true&lang=js"

import "./authentication.vue?vue&type=style&index=0&id=0bdea1b0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bdea1b0"]])

export default __exports__